import React from 'react';
import AuthService from './authService';
import dateTimeHelper from '../Helpers/datetimeHelper';

export default class ReportRunnerService extends React.Component {
  static async RequestReport() {
    const url = '/api/ReportRunner/ExportReferralShopReportToExcel/';
    return AuthService.getInstance().CallBackendFunctionPut(url /*, JSON.stringify(params)*/);
  }

  static async RequestSapReconciliationReport(params) {
    params.FinalizedBefore = dateTimeHelper.toYYYYsMMsDD(params.FinalizedBefore);
    params.FinalizedAfter = dateTimeHelper.toYYYYsMMsDD(params.FinalizedAfter);
    const url = '/api/ReportRunner/ExportSapReconciliationReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(params));
  }

  static async RequestQboInvoiceReport(params) {
    params.FinalizedBefore = dateTimeHelper.toYYYYsMMsDD(params.FinalizedBefore);
    params.FinalizedAfter = dateTimeHelper.toYYYYsMMsDD(params.FinalizedAfter);
    const url = '/api/ReportRunner/ExportQBOInvoiceReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(params));
  }

  static async RequestQboCreditMemoReport(params) {
    params.FinalizedBefore = dateTimeHelper.toYYYYsMMsDD(params.FinalizedBefore);
    params.FinalizedAfter = dateTimeHelper.toYYYYsMMsDD(params.FinalizedAfter);
    const url = '/api/ReportRunner/ExportQBOCreditMemoReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(params));
  }

  static CreateDataExport(createItem) {
    createItem.ToDate = dateTimeHelper.toYYYYsMMsDD(createItem.ToDate);
    createItem.FromDate = dateTimeHelper.toYYYYsMMsDD(createItem.FromDate);
    createItem.Report = createItem.Report ? createItem.Report.toString() : null;
    createItem.Client = createItem.Client ? createItem.Client.toString() : null;
    createItem.Project = createItem.Project ? createItem.Project.toString() : null;

    const url = '/api/ExcelDataExport/CreateDataExport/';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(createItem));
  }

  static async ExportPersonaReportToExcel(searchItem) {
    const searchParams = {
      SearchItem: searchItem,
    };
    const url = '/api/ReportRunner/ExportPersonaReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(searchParams));
  }

  static async ExportEmailCampaignReportToExcel(searchItem) {
    const searchParams = {
      SearchItem: searchItem,
    };
    const url = '/api/ReportRunner/ExportEmailCampaignReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(searchParams));
  }

  static async ExportTextMessageReportToExcel(searchItem) {
    const searchParams = {
      SearchItem: searchItem,
    };
    const url = '/api/ReportRunner/ExportTextMessageReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(searchParams));
  }

  static async ExportSchedulingReportToExcel(searchItem) {
    const searchParams = {
      SearchItem: searchItem,
    };
    const url = '/api/ReportRunner/ExportSchedulingReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(searchParams));
  }

  static async RequestARAgeingReport(params) {
    const url = '/api/ReportRunner/ExportARAgeingReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(params));
  }

  static async RequestEvaluatorPaymentsExportReport(params) {
    const url = '/api/ReportRunner/ExportEvaluatorPaymentsReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(params));
  }

  static async RequestUnappliedPrepaymentReport(params) {
    const url = '/api/ReportRunner/ExportUnappliedPrepaymentReportToExcelAsync';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(params));
  }

  static async RequestEvaluatorCountReport(params) {
    const url = '/api/TpEvaluator/ExportEvaluatorCountReport';
    return AuthService.getInstance().CallBackendFunctionPost(url, JSON.stringify(params));
  }
}
